import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelToDisplay } from '@iotv/datamodel-core';
import { TabContext, TabList } from '@mui/lab';
import { Tab, Typography } from '@mui/material';
import { useTabHandler } from '../../../hooks/useTabHandler';
import { BatchPutExample } from './devTsxTabs/BatchPut';
import { IndirectInference } from './devTsxTabs/IndirectInference';
import { RecursiveGraphQuery } from './devTsxTabs/RecursiveGraphQuery';
import { TableQueryFilter } from './devTsxTabs/TableQueryFilter';
import { Wideawake } from './devTsxTabs/Wideawake';
export const Slot3 = ({}) => {
    const tabsToDisplay = {
        BatchPut: (value) => _jsx(BatchPutExample, { value }, value),
        TableQueryFilter: (value) => _jsx(TableQueryFilter, { value }, value),
        RecursiveQueryPath: (value) => _jsx(RecursiveGraphQuery, { value }, value),
        IndirectInference: (value) => _jsx(IndirectInference, { value }, value),
        Wideawake: (value) => _jsx(Wideawake, { value }, value),
    };
    const { handlers: { handleTabChange }, state: [[tabIdx, setTabIdx]], } = useTabHandler(tabsToDisplay);
    const getTabName = (idx) => Object.keys(tabsToDisplay)[idx];
    const getTabIndex = (str) => Object.keys(tabsToDisplay).indexOf(str);
    return (_jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "Developer only examples" }), _jsxs(TabContext, { value: getTabName(tabIdx), children: [_jsx(TabList, { onChange: (e, newTabName) => setTabIdx(getTabIndex(newTabName)), children: Object.keys(tabsToDisplay).map((k) => (_jsx(Tab, { label: camelToDisplay(k), value: k }, k))) }), Object.entries(tabsToDisplay).map(([k, fn]) => fn(k))] })] }));
};
